export default __webpack_public_path__ + "static/desk02-e82c6b3a7ee8385a8cee89bcdc274748.png";